<template>
    <g>
        <path 
            v-bind="{
                class : 'tool_svgElem',
                id   : tool.id + '-body',
                d    : d_curva(),      
                fill : fill,
            }"
        >
            <!-- animate
                v-if="isToolActive"
                attributeType="XML"
                attributeName="stroke-width"
                calcMode="discrete"
                values="1;30"
                begin="0s"
                dur="0.8s"
                repeatCount="indefinite"/ -->            
        </path>
    </g>
</template>

// =========================================================================================
// =========================================================================================

<script>
import { tools } from '../../mixins/tools';
import { paths } from '../../mixins/paths';

// =========================================================================================

export default {
    name : 'curvCMP',
    props: {
        fill  : { type: String  }
    }, 

    // -----------------------------------------------------------------

    mixins: [tools, paths],

    // -----------------------------------------------------------------

    data () {
        return {
        }
    },

    // -----------------------------------------------------------------

    computed: {   
    },

    // -----------------------------------------------------------------

    methods: {
    }
}
</script>

// =========================================================================================
// =========================================================================================

<style scoped>
</style>